import * as React from "react";
import { EMPTY_ARRAY } from "@/react/empty";

import tenantDataToOptions from "./tenantDataToOptions";

/**
 * This hook controls a react-select-type drop-down for PBX selection based on
 * the current customer data.
 *
 * Customer data may contain an attribute called preselectedPbxId which
 * contains the ID of the PBX that the user selected via {@link ResultCard.jsx}.
 *
 * @param stagedCustomer - (staged) customer data, see {@link ResultCard.jsx}.
 */
const useManagedTenantSelection = (stagedCustomer) => {
  const tenantData = stagedCustomer?.tenantData ?? EMPTY_ARRAY;
  const tenantOptions = React.useMemo(
    () => tenantDataToOptions(tenantData),
    [tenantData]
  );
  const [selectedTenant, setSelectedTenant] = React.useState(
    tenantOptions?.[0] ?? null
  );

  React.useEffect(() => {
    const _preselectedTenantId = stagedCustomer?.preselectedTenantId ?? null;
    if (_preselectedTenantId) {
      const tenantOption = (tenantOptions ?? []).find(
        (option) => option.value === _preselectedTenantId
      );

      if (!tenantOption) {
        console.error(
          "No tenant option matches the preselectedTenantId. " +
            JSON.stringify({ tenantOptions, _preselectedTenantId })
        );

        setSelectedTenant(tenantOptions?.[0] ?? null);
        return;
      }

      setSelectedTenant(tenantOption);
    }
  }, [tenantOptions, stagedCustomer]);

  return [tenantOptions, selectedTenant];
};

export default useManagedTenantSelection;
